let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Voc1")).then(() => parcelRequire('AfoMu'));